<template>
  <div class="notifications-button" @click="showModal">
    <BbIcon class="notifications-icon" name="notification" size="small" />
    <div v-if="unreadNotifications.length" class="notifications-count">
      {{ unreadNotifications.length }}
    </div>
  </div>
</template>

<script>
import { computed, watch } from 'vue';
import { useStore } from 'vuex';

import { CURRENT_DIALOG } from '~/constants/conversationModels';

import useModals from '~/composables/useModals';
import useNotifications from '~/composables/useNotifications';

export default {
  name: 'NotificationsMenu',
  components: {},

  setup() {
    const store = useStore();
    const { setCurrentDocumentsDialog } = useModals();
    const { notifications } = useNotifications();
    const unreadNotifications = computed(() => notifications.value.filter((n) => !n.readAt));
    const showModal = () => {
      setCurrentDocumentsDialog(CURRENT_DIALOG.notifications_panel);
    };

    watch(unreadNotifications, (newValue) => {
      newValue.forEach((notification) => {
        if (notification.actionName === 'Download' && notification.downloadId) {
          store.dispatch('documentStore/removeDownloadInProgress', notification.downloadId);
        }
      });
    });

    return {
      showModal,
      unreadNotifications,
    };
  },
};
</script>

<style scoped lang="scss">
.notifications-button {
  position: relative;
  padding: $bb-spacing-2;
  border-radius: 100px;
  cursor: pointer;
  border: 1px solid $bb-neutral-4;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: inherit;
  justify-content: center;

  .notifications-icon {
    color: $bb-neutral-1;
  }

  .notifications-count {
    @include bb-medium-text-styles('xs');
    color: $bb-neutral-1;
    background-color: $bb-neutral-0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -4px;
    right: -6px;
    width: 18px;
    height: 16px;
    border: 1px solid $bb-neutral-4;
    border-radius: 100px;
  }
}
</style>
